import apiClient from '../apiClient';
import { GET_ACCOMODATION_EXPORT_DATA } from '../apiUrl';

const getExportAccomodationProfileaApi = () => {
  return apiClient.get(GET_ACCOMODATION_EXPORT_DATA);
};

export default getExportAccomodationProfileaApi;
